import { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Users, Gauge, Fuel, AlertTriangle, Wrench } from "lucide-react";

export const DashboardVehicule = ({ vehicule }) => {
  const { token } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/vehicules/${vehicule.id}/dashboard`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => { if (alive) setData(res.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, [vehicule]); // eslint-disable-line

  if (!data) return null;

  const stats = [
    { label: `Km ce mois (${data.month})`, value: `${data.km_mois.toLocaleString()} km`, icon: Gauge, color: "text-indigo-600" },
    { label: "Carburant ce mois", value: `${data.carburant_mois.toFixed(2)} €`, icon: Fuel, color: "text-amber-600" },
    { label: "Problèmes ouverts", value: data.problemes_ouverts, icon: AlertTriangle, color: data.problemes_ouverts > 0 ? "text-red-600" : "text-emerald-600" },
    { label: `Coûts ${data.year} (entretien + répar.)`, value: `${(data.cout_entretiens_annee + data.cout_problemes_annee).toFixed(2)} €`, icon: Wrench, color: "text-emerald-600" },
  ];

  return (
    <div className="space-y-4" data-testid="vehicule-dashboard">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {stats.map(s => (
          <Card key={s.label}>
            <CardContent className="p-3">
              <p className="text-xs text-slate-500 flex items-center gap-1"><s.icon className={`w-3.5 h-3.5 ${s.color}`} />{s.label}</p>
              <p className={`text-xl font-bold ${s.color}`}>{s.value}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {(data.conducteurs || []).length > 0 && (
        <Card data-testid="conducteurs-card">
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Users className="w-5 h-5 text-indigo-600" />Historique conducteurs
              {data.dernier_conducteur && (
                <Badge variant="outline" className="text-xs font-normal">
                  {data.trip_en_cours ? "🚚 Au volant : " : "Dernier : "}<b className="ml-1">{data.dernier_conducteur}</b>
                </Badge>
              )}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-1">
              {data.conducteurs.map(c => (
                <div key={c.conducteur} className="flex items-center justify-between py-2 border-b border-slate-100 text-sm last:border-0" data-testid={`conducteur-${c.conducteur}`}>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center font-semibold text-xs">
                      {c.conducteur.slice(0, 2).toUpperCase()}
                    </div>
                    <div>
                      <p className="font-medium text-slate-800">{c.conducteur}</p>
                      <p className="text-xs text-slate-500">
                        {c.nb_utilisations} utilisation{c.nb_utilisations > 1 ? "s" : ""}
                        {c.derniere_date && ` · dernière le ${c.derniere_date.slice(0, 10)}`}
                        {c.derniere_destination && ` · ${c.derniere_destination}`}
                      </p>
                    </div>
                  </div>
                  <span className="font-bold text-indigo-600">{c.km_total.toLocaleString()} km</span>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default DashboardVehicule;
